import { z } from 'zod'
import {
  EntityEnum,
  OrganisationEnum,
  RegionEnum,
  CurrencyEnum,
  UserLanguageEnum,
  ProfileTypeEnum,
  PlatformEnum,
  OsEnum,
  PageTypeEnum,
  FunnelStepEnum,
  LobEnum,
  LobCategoryEnum,
} from './enums'

export const baseSchemaValidation = z.object({
  entity_info: z.object({
    organisation: OrganisationEnum,
    entity: EntityEnum,
    region: RegionEnum,
    currency: CurrencyEnum,
    user_language: UserLanguageEnum,
  }),
  user_context: z.object({
    profile_type: ProfileTypeEnum,
  }),
  device_context: z.object({
    platform: PlatformEnum,
    os: OsEnum,
  }),
  page_context: z.object({
    page_type: PageTypeEnum,
    funnel_step: FunnelStepEnum,
    page_name: z.string().min(1, { message: 'page_name cannot be empty' }),
    lob: LobEnum,
    lob_category: LobCategoryEnum,
  }),
})

export const formatZodError = (error: z.ZodError) => {
  return error.issues.map(issue => ({
    path: issue.path.join('.'),
    message: issue.message,
    code: issue.code,
  }))
}
